import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import PageContainer from './components/common/PageContainer';
import ViewHeader from './components/ViewHeader';
import ProductsAttributesTable from './components/ProductsAttributesTable';

export default function ProductsAttributesPage() {
  const navigate = useNavigate();

  return (
    // 🔴 `minHeight`, nicht `height` (2026-10-19, B3): die feste Hoehe war auf den
    // senkrechten Deckel der Tabelle abgestimmt. Seit der weg ist, waechst die
    // Tabelle mit ihrem Inhalt, und die SEITE ist der Roller — eine feste
    // Behaelterhoehe liesse sie sichtbar herauslaufen.
    <PageContainer sx={{ minHeight: 'calc(100vh - 64px)' }}>
      <ViewHeader
        title="Product Attribute Editor"
        breadcrumbs={[
          { label: 'Home', href: '/' },
          { label: 'Products', href: '/products' },
          { label: 'Attribute editor' },
        ]}
        actions={[
          { key: 'back-products', label: 'Back to products', onClick: () => navigate('/products'), variant: 'text' },
        ]}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <ProductsAttributesTable />
      </Box>
    </PageContainer>
  );
}
